import { hasPermission } from "../../Config/permissions.js";

export const normalizeBoolean = (value) =>
  value === true || value === "true" || value === 1 || value === "1";

export const getDefaultHomePath = (user) => {
  const userType = user?.Type;

  if (userType === "Account" && user?.AccountID) {
    return `/Account/${user.AccountID}`;
  }

  if (userType === "Distributor" && user?.DistributorID) {
    return `/Distributor/${user.DistributorID}`;
  }

  if (userType === "Manufacturer" && user?.ManufacturerID) {
    return `/Manufacturer/${user.ManufacturerID}`;
  }

  return "/";
};

export const canAccessDirectOrderActions = (user) => {
  if (!user) return false;

  return (
    user.Type !== "Account" ||
    hasPermission(user, "order_account.direct")
  );
};

export const canAccessNewDirectOrder = (user) =>
  (user?.Type === "Admin" && normalizeBoolean(user?.IsSuperAdmin)) ||
  (user?.Type === "Account" &&
    normalizeBoolean(user?.IsNewOrderEnabled) &&
    hasPermission(user, "order_account.direct"));

export const canAccessConsignmentOrderActions = (user) =>
  user?.Type === "Account" && hasPermission(user, "order_account.consignment");

export const canSubmitIvr = (user) =>
  user?.Type === "Admin" ||
  (user?.Type === "Account" &&
    normalizeBoolean(user?.EnableIVR) &&
    hasPermission(user, "ivr_account.submit"));

export const canViewIvrDashboard = (user) => {
  if (!user) return false;

  return (
    user.Type !== "Account" ||
    (normalizeBoolean(user.EnableIVR) &&
      hasPermission(user, "ivr_account.view"))
  );
};
